import type { SiteEnergyWizard } from "../../../utils/backend-types";
import { SiteTasksBox } from "../components/SiteTasksBox";
import { EnergyAssignment } from "./EnergyAssignment/EnergyAssignment";

type EnergyWizardProps = {
  energyWizard: SiteEnergyWizard;
  onEnergyWizardUpdated: () => void;
};

export enum AssignmentType {
  MeasurementData = "Energiedaten"
}

function EnergyWizard({
  energyWizard,
  onEnergyWizardUpdated
}: EnergyWizardProps) {
  return (
    <SiteTasksBox>
      <EnergyAssignment
        energyWizard={energyWizard}
        isDone={energyWizard.phases.meters.done}
        type={AssignmentType.MeasurementData}
        onEnergyWizardUpdated={onEnergyWizardUpdated}
      />
    </SiteTasksBox>
  );
}

export { EnergyWizard };
